import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  flex-direction: column;

  font-family: "Mulish";

  background-color: #363740;

  position: relative;

  .image-wrapper {
    display: flex;

    justify-content: center;

    height: 8rem;
    width: 100%;

    img {
      width: 3rem;

      transition: all 0.3s;
    }
  }

  .item {
    background: none;
    border: none;

    color: rgb(164, 166, 179);
    text-decoration: none;
    font-size: 0.9rem;

    img {
      height: 1.3rem;
      margin-right: 1.8rem;
    }
  }

  ul {
    white-space: nowrap;
    list-style: none;

    width: 3.5rem;

    overflow: hidden;

    transition: all 0.2s;

    li {
      display: flex;

      padding-left: 1rem;

      height: 3rem;
      width: 100%;

      margin: 0.5rem 0;

      align-items: center;

      transition: all 0.1s;
    }

    li.active {
      border-left: 3px solid #3751ff;
    }

    li:hover {
      background-color: rgba(255, 255, 255, 0.1);

      color: rgb(55, 81, 255);
    }
  }

  &:hover {
    .image-wrapper {
      img {
        transition-delay: 0.5s;

        width: 6rem;
      }
    }

    ul {
      transition-delay: 0.5s;

      width: 19rem;
    }
  }

  form {
    display: flex;

    position: absolute;

    align-items: center;

    height: 4rem;

    bottom: 1rem;
  }
`;
